import apiClient from '../lib/api-client';

export const policyTransactionService = {
  // Get all life policies with transactions
  getAllPolicyTransactions: async () => {
    try {
      const response = await apiClient.get('/policy-transaction');
      return response.data;
    } catch (error) {
      console.error('Error fetching policy transactions:', error);
      throw error;
    }
  },

  // Get specific policy transactions by policy number
  getPolicyTransactionsByNumber: async (policyNumber) => {
    try {
      const response = await apiClient.get('/policy-transaction', {
        params: {
          policy_number: policyNumber,
          month: '',
          year: '',
          amount: '',
          reference: ''
        }
      });
      return response.data;
    } catch (error) {
      console.error(`Error fetching transactions for policy ${policyNumber}:`, error);
      throw error;
    }
  }
};
